// extracted by mini-css-extract-plugin
export default {"container":"ProtectedRoute_container__w4g2t","subTitle":"ProtectedRoute_subTitle__P7IFq"};